import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-logo',
  templateUrl: './logo.component.html',
  styleUrls: ['./logo.component.css']
})
export class LogoComponent implements OnInit {
  @Input() Width: number = 30;
  @Input() Height: number = 30;

  constructor() { }

  ngOnInit(): void {
  }

}
